import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  TextInput,
  Button,
  I18n,
  Popup,
  Heading,
} from 'components';

import {
  PHONE_MASK,
  EMAIL_REGEXP,
} from 'constants/common';

import {
  formatPhone,
  cleanupPhone,
} from 'utils/formatString';

import {
  NOTIFICATION_POINTS_TYPES,
  REQUIRED_PHONE_LENGTH,
} from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class NotificationPointEditPopup extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      pointValue: props.value,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.isEditing && !props.isEditing) {
      this.setState({
        pointValue: props.value,
      });
    }
  }

  getInput() {
    const { type } = this.props;

    const {
      pointValue,
      error,
    } = this.state;

    switch (type) {
      case NOTIFICATION_POINTS_TYPES.SMS:
        return (
          <TextInput
            size="big"
            className={cx('textInput', { fail: !!error })}
            value={formatPhone(pointValue)}
            onChange={(value) => {
              const newValue = cleanupPhone(value);

              this.setState({
                pointValue: newValue,
                error: this.validate(newValue),
              });
            }}
            mask={PHONE_MASK}
          />
        );
      case NOTIFICATION_POINTS_TYPES.EMAIL:
        return (
          <TextInput
            size="big"
            className={cx('textInput', { fail: !!error })}
            value={pointValue}
            onChange={(value) => this.setState({
              pointValue: value,
              error: this.validate(value),
            })}
          />
        );
      default:
        return null;
    }
  }

  validate(value) {
    return this.isValid(value) ? null
      : `settings.points.${this.props.type}.error`;
  }

  isValid(value) {
    switch (this.props.type) {
      case NOTIFICATION_POINTS_TYPES.SMS:
        return !value || value.length === REQUIRED_PHONE_LENGTH;
      case NOTIFICATION_POINTS_TYPES.EMAIL:
        return !value || value.match(EMAIL_REGEXP);
      default:
        return true;
    }
  }

  isSaveDisabled() {
    return this.props.value === this.state.pointValue
           || !this.isValid(this.state.pointValue);
  }

  render() {
    const {
      value: defaultValue,
      savePointValue,
      cancelPointValue,
      type,
      isRecoveryPassword,
      isSaving,
      isEditing,
    } = this.props;

    const {
      error,
      pointValue,
    } = this.state;

    return (
      <Popup
        opened={isEditing}
        onClose={() => !isSaving && cancelPointValue()}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();

            if (!this.isSaveDisabled() && !isSaving) {
              savePointValue(pointValue);
            }
          }}
        >
          <Heading className={cx('title')} level={1}>
            {defaultValue ? (
              <I18n path={`settings.points.${type}.editTitle`} />
            ) : (
              <I18n path={`settings.points.${type}.addTitle`} />
            )}
          </Heading>
          <Heading className={cx('subtitle')} level={5}>
            <I18n path={`settings.points.${type}.${isRecoveryPassword ? 'recoveryPasswordHint' : 'hint'}`} />
          </Heading>
          <div className={cx('inputWrapper')}>
            {this.getInput()}
            {error
              && (
              <div className={cx('error')}>
                <I18n path={error} />
              </div>
              )}
          </div>
          <div className={cx('saveButtonWrapper')}>
            <Button
              className="big"
              type="submit"
              disabled={this.isSaveDisabled()}
              isLoading={isSaving}
            >
              <I18n path="common.save" />
            </Button>
          </div>
        </form>
      </Popup>
    );
  }
}

NotificationPointEditPopup.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  isRecoveryPassword: PropTypes.bool,
  isSaving: PropTypes.bool,
  isEditing: PropTypes.bool,
  savePointValue: PropTypes.func,
  cancelPointValue: PropTypes.func,
};

export default NotificationPointEditPopup;
